// Zentrale Währungs-Helfer.
// Die Webseite zeigt Preise auf den englischen Seiten in US-Dollar und auf den
// deutschen Seiten in Euro. Die Basiswährung ist der EURO: alle Preise werden in
// Euro gepflegt. Der Umrechnungskurs (1 € → US$) wird im Backstage gepflegt und in
// der Datenbank gespeichert. Bis er geladen ist, gilt der Standardwert unten.
export const EUR_TO_USD = 1.0753;

// Aktiver Umrechnungskurs (1 € = x US$) – wird zur Laufzeit aus der Datenbank gesetzt.
let activeRate = EUR_TO_USD;

export const getEurToUsdRate = (): number => activeRate;

export const setEurToUsdRate = (rate: number): void => {
  const value = Number(rate);
  if (Number.isFinite(value) && value > 0) {
    activeRate = value;
  }
};

export const currencySymbol = (isDe: boolean): string => (isDe ? "€" : "US$");

// Formatiert eine Zahl mit Tausender-Trennzeichen je nach Sprache:
// Deutsch → "1.637", Englisch → "1,637". Es werden keine Nachkommastellen angezeigt.
export const formatNumber = (value: number, isDe: boolean): string =>
  new Intl.NumberFormat(isDe ? "de-DE" : "en-US", {
    maximumFractionDigits: 0,
  }).format(Number.isFinite(value) ? value : 0);

// Rechnet einen Euro-Betrag in US-Dollar um (gerundet) und nutzt dabei den
// aktuell gepflegten Umrechnungskurs.
export const toUsd = (eur: number, rate: number = activeRate): number =>
  Math.round(eur * rate);

// Formatiert einen bereits vorliegenden Betrag mit Tausender-Trennzeichen
// und dem Währungssymbol am Ende (z. B. "1.637 €" bzw. "1,637 US$").
export const formatAmount = (amount: number, isDe: boolean): string =>
  `${formatNumber(amount, isDe)} ${currencySymbol(isDe)}`;

// Formatiert einen Euro-Betrag je nach Sprache (Deutsch: Euro, Englisch: US-Dollar).
export const money = (eur: number, isDe: boolean, rate: number = activeRate): string =>
  formatAmount(isDe ? eur : toUsd(eur, rate), isDe);